import { useState } from 'react';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import DegreeInfoPanel from './educationDegreeInformationPanel';
import SchoolingInfoPanel from './schoolingInformationPanel';
import EducationIcon from '../../../../../assets/images/Ic_Education.png';
import _ from 'lodash';

const EducationInfo = ({ education = {} }) => {
  const [showAll, setShowAll] = useState(false);

  const calculateEducationLength = (education) => {
    const schoolingItems = [
      _.get(education, 'tenth'),
      _.get(education, 'twelfth')
    ].filter((item) => item && isValidSchoolingData(item));
    const graduationLst = _.get(education, 'hasGraduationDegree') === 'YES' ? _.get(education, 'graduationLst') : [];
    const pgLst = _.get(education, 'hasPg') === 'YES' ? _.get(education, 'pgLst') : [];
    const doctorateLst = _.get(education, 'hasDoctorate') === 'YES' ? _.get(education, 'doctorates') : [];
    return schoolingItems.length + graduationLst.length + pgLst.length + doctorateLst.length;
  };

  const isValidSchoolingData = (data) => {
    return (
      !!_.get(data, 'schoolName') ||
      !!_.get(data, 'schoolDetails.startYear') ||
      !!_.get(data, 'schoolDetails.endYear') ||
      !!_.get(data, 'schoolDetails.cgpa') ||
      !!_.get(data, 'schoolDetails.percentage')
    );
  };

  const schoolingItems = [
    { type: 'schooling', title: '12th Grade', data: _.get(education, 'twelfth') },
    { type: 'schooling', title: '10th Grade', data: _.get(education, 'tenth') },
  ].filter((item) => item.data && isValidSchoolingData(item.data));

  const degreeItems = [
    ...(_.get(education, 'hasDoctorate') === 'YES' ? _.get(education, 'doctorates', []) : []),
    ...(_.get(education, 'hasPg') === 'YES' ? _.get(education, 'pgLst', []) : []),
    ...(_.get(education, 'hasGraduationDegree') === 'YES' ? _.get(education, 'graduationLst', []) : []),
  ].map((data) => ({ type: 'degree', data }));

  const allItems = [...degreeItems, ...schoolingItems];

  const visibleItems = showAll ? allItems : allItems.slice(0, 4);

  return (
    <Container className="pt-2 education-container">
      <Row>
        <Col>
          <h3 className="candidate-heading">
            Education ({calculateEducationLength(education)})
            <img src={EducationIcon} alt="Education" className="profile-work-experience-nav-icon" />
          </h3>
        </Col>
      </Row>

      {/* Render Education Items */}
      <Container>
        {visibleItems.map((item, index) => (
          item.type === 'schooling' ? (
            <SchoolingInfoPanel
              key={`school-${index}`}
              colorSeed={Math.random()}
              schoolData={item.data}
              title={item.title}
            />
          ) : (
            <DegreeInfoPanel
              key={`degree-${index}`}
              colorSeed={Math.random()}
              pgData={item.data}
            />
          )
        ))}
      </Container>

      {/* View More/Collapse Button */}
      {allItems.length > 4 && (
        <Row>
          <Col>
            <a
              className="education-view-all"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? 'View Less' : 'View All'}&nbsp;
              <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown} />
            </a>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default EducationInfo;